import { API_PATHS } from "../../../../../../API/api_paths";
import { useAppSelector } from "../../../../../../redux";
import { addProxyUrlToProfileImage } from "../../../../../../utils";
import UserInfo from "../../../../../Common/UserInfo";
import { usePostCardContext } from "../PostCardContent";

export const HeaderLeft = () => {
  const { postId, isWithinRepostModal } = usePostCardContext();
  const { processed_posts } = useAppSelector((state) => state.newsfeed);
  const { name, profilePicture, activeDuration, headline, user_id } =
    processed_posts[postId].UserDetails;

  return (
    <UserInfo
      headline={headline}
      id={user_id}
      name={name}
      profile_picture={
        profilePicture.String.startsWith("anon")
          ? API_PATHS.global.anonymous_persona + profilePicture.String
          : addProxyUrlToProfileImage(profilePicture.String)
      }
      activeDuration={activeDuration}
      showPostedDate={true}
      avatarSize="Large-56"
      showUserInfoOnHover={!isWithinRepostModal}
    />
  );
};
